// extracted by css-extract-rspack-plugin
export default {"container":"_8b1766c2","headerText":"_4a877c67","sectionWrapper":"_ec0c20bf"};